// extracted by mini-css-extract-plugin
export default {"container":"MealPlannerLogin_container__dyYwB","containerCenter":"MealPlannerLogin_containerCenter__X34YG"};